export default __webpack_public_path__ + "static/media/loading.dbb22bcf.gif";